// @ts-check

/** @type {any} */
let LiveMapIcons = {};

LiveMapIcons.liveMapMarkerErrorLarge = `
<svg xmlns="http://www.w3.org/2000/svg" width="24.003" height="24" viewBox="0 0 24.003 24">
<path data-name="Rectangle 4595" style="fill:none" d="M0 0h24v24H0z" transform="translate(.003)"/>
<g data-name="Path 11756" style="fill:#d93a5b">
    <path d="M17.488 20.689H2.035c-1.049 0-2.004-.55-2.556-1.47a3.025 3.025 0 0 1-.095-3l7.77-14.832C7.706.345 8.713-.275 9.85-.275c1.137 0 2.144.62 2.694 1.658l.002.004.002.004 7.68 14.83a3 3 0 0 1-.091 2.973 3.062 3.062 0 0 1-2.649 1.495zm-7.918-4.65h.472v-.207H9.57v.207zm.138-3.62h.107l.187-4.8h-.481l.187 4.8z" style="stroke:none" transform="translate(1.969 2.275)"/>
    <path d="M17.488 19.689c1.59 0 2.561-1.678 1.855-3.003L11.66 1.851C10.865.35 8.834.35 8.04 1.85L.269 16.686c-.707 1.325.265 3.003 1.766 3.003h15.453M8.57 14.832h2.472v2.207H8.57v-2.207M8.48 6.619h2.561l-.265 6.8h-2.03l-.266-6.8m9.007 15.07H2.035c-1.403 0-2.68-.731-3.414-1.955-.742-1.238-.787-2.726-.12-3.982L6.271.915c.715-1.35 2.086-2.19 3.578-2.19s2.863.84 3.578 2.19l.008.016 7.678 14.827a3.991 3.991 0 0 1-.12 3.95 4.054 4.054 0 0 1-3.506 1.98z" style="fill:#fff;stroke:none" transform="translate(1.969 2.275)"/>
</g>
</svg>
`;

LiveMapIcons.liveMapMarkerWarningLarge = `
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
    <g data-name="Group 9759">
        <g data-name="Group 9763">
            <g data-name="Ellipse 608" style="fill:#fbae2f;stroke:#fff;stroke-width:2px">
                <circle cx="12.5" cy="12.5" r="12.5" style="stroke:none"/>
                <circle cx="12.5" cy="12.5" r="11.5" style="fill:none"/>
            </g>
            <g data-name="Group 9707">
                <path data-name="Path 11766" d="M11024.563 571.207h3.074l-.512 8.46h-1.88z" transform="translate(-11013.639 -566.145)" style="fill:#fff"/>
                <path data-name="Rectangle 4590" transform="translate(11.077 15.5)" style="fill:#fff" d="M0 0h3v3H0z"/>
            </g>
        </g>
        <path data-name="Rectangle 4596" transform="translate(1)" style="fill:none" d="M0 0h24v24H0z"/>
    </g>
</svg>
`;


LiveMapIcons.liveMapMarkerErrorSmall = `
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <g data-name="Group 9753">
        <g data-name="Ellipse 609" transform="translate(4 2.487)" style="fill:#fff;stroke:#707070">
            <ellipse cx="3" cy="5.5" rx="3" ry="5.5" style="stroke:none"/>
            <ellipse cx="3" cy="5.5" rx="2.5" ry="5" style="fill:none"/>
        </g>
        <path data-name="Path 11755" d="M13.866 12.508 8.363 1.556a1.427 1.427 0 0 0-2.594 0L.2 12.508a1.517 1.517 0 0 0 1.265 2.217h11.07a1.522 1.522 0 0 0 1.331-2.217zm-5.946.261H6.148v-1.63H7.92zM7.73 10.1H6.275l-.19-5.02H7.92z" transform="translate(-.034 -.725)" style="fill:#ff476d"/>
    </g>
</svg>
`;

LiveMapIcons.liveMapMarkerWarningSmall = `
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <circle data-name="Ellipse 608" cx="7" cy="7" r="7" style="fill:#fbae2f"/>
    <g data-name="Group 9707">
        <path data-name="Path 11766" d="M11024.563 571.207h2.1l-.349 6.311h-1.283z" transform="translate(-11018.689 -568.856)" style="fill:#fff"/>
        <path data-name="Rectangle 4590" transform="translate(6.027 9.629)" style="fill:#fff" d="M0 0h2.024v2H0z"/>
    </g>
</svg>
`;




export { 
  LiveMapIcons
};
